<template>
  <div class="landing-page">
    <div class="hero-section">
      <div class="content-wrapper">
        <div class="left-content">
          <CallToAction />
          <div class="cta-buttons">
            <div v-if="auth.user" class="try-button">
              <router-link to="/product">
                <ButtonTemplate :button-text="'Provalo ora'" />
              </router-link>
            </div>
            <div v-if="!auth.user" class="try-button">
              <router-link :to="{ name: 'login' }">
                <ButtonTemplate :button-text="'Provalo ora'" />
              </router-link>
            </div>
          </div>
          <ScoreCards />
        </div>
      </div>
    </div>
    <div v-if="showFreeTrialForm" class="modal-overlay" @click="closePopup">
      <div class="modal-content" @click.stop>
        <FreeTrialForm @closePopup="closePopup" />
      </div>
    </div>
  </div>
</template>

<script>
import CallToAction from '../components/screens/CallToAction.vue';
import FreeTrialForm from '../components/screens/FreeTrial.vue';
import ButtonTemplate from '../components/widgets/button.vue';
import ScoreCards from '../components/widgets/ScoreCards.vue';
import { useAuthStore } from '../stores/authStore';

export default {
  name: 'MainPage',
  components: {
    CallToAction,
    ButtonTemplate,
    FreeTrialForm,
    ScoreCards,
  },
  data() {
    return {
      showFreeTrialForm: false
    };
  },
  computed: {
    auth() {
      return useAuthStore();
    }
  },
  methods: {
    showPopup() {
      this.showFreeTrialForm = true;
    },
    closePopup() {
      this.showFreeTrialForm = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff, #56BCEE);
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-section {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  max-width: 1600px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.left-content {
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  width: 100%;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  margin: 0;
}

.try-button {
  --button-border-color: #2e4eed;
  --button-text-color: #ffffff;
  --button-background-color: #2e4eed;
  --button-background-hover-color: #1e3ed8;
  --button-border-radius: 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 0;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 1rem;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>